import {
    Keyboard,
    Mouse,
    Hand,
    PersonStanding,
    ToggleRight,
    Route,
    Volume2,
    ScanText,
    ScanQrCode,
} from 'lucide-react'
import { ReactComponent as microphone } from '../../Assets/aiCode/inputs/microphone.svg'
import { ReactComponent as camera } from '../../Assets/aiCode/inputs/camera.svg'
import { ReactComponent as texts } from '../../Assets/aiCode/outputs/texts.svg'
import { ReactComponent as image } from '../../Assets/aiCode/outputs/image.svg'
import { ReactComponent as video } from '../../Assets/aiCode/outputs/video.svg'
import { ReactComponent as button1 } from '../../Assets/aiCode/outputs/button1.svg'
import { ReactComponent as button2 } from '../../Assets/aiCode/outputs/button2.svg'
import { ReactComponent as motion } from '../../Assets/aiCode/ai/motion.svg'
import { ReactComponent as colour } from '../../Assets/aiCode/ai/colour.svg'
import { ReactComponent as face } from '../../Assets/aiCode/ai/face.svg'
import { ReactComponent as object } from '../../Assets/aiCode/ai/object.svg'
import { ReactComponent as voice } from '../../Assets/aiCode/ai/voice.svg'

const aiCodeIcons = {
    inputs: {
        keyboard: Keyboard,
        mouse: Mouse,
        microphone,
        camera,
        button1,
        button2,
        toggle: ToggleRight,
    },
    outputs: {
        texts,
        image,
        video,
        audio: Volume2,
    },
    ai: {
        motion,
        colour,
        face,
        object,
        voice,
        pose: PersonStanding,
        hand: Hand,
        tracking: Route,
        ocr: ScanText,
        marker: ScanQrCode,
    },
}

export const getAiCodeIcon = (categorySlug, iconKey) =>
    (aiCodeIcons[categorySlug] && aiCodeIcons[categorySlug][iconKey]) || null

export default aiCodeIcons
